import { observer } from 'mobx-react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { IsgiTypes } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import {
  CaseColumnNames,
  CaseFilterIds,
} from '@new/domains/operations/screens/CasesV2/utils/config'

import { CheckBoxOption, CheckBoxWrapper } from './commonFilterStyles.style'

const isgiOptions = [
  {
    value: IsgiTypes.isgi,
    label: <CheckBoxOption>ISGI</CheckBoxOption>,
    hasFullWidth: true,
  },
  {
    value: IsgiTypes.notIsgi,
    label: <CheckBoxOption>Not ISGI</CheckBoxOption>,
    hasFullWidth: true,
  },
]

const _InStayGuestIssueFilter = () => {
  const { setFilterValue, inStayGuestIssue } = casesFiltersStore

  const handleDataFilter = (value?: string[] | undefined) => {
    setFilterValue(CaseFilterIds.InStayGuestIssue, value)
  }

  return (
    <CheckBoxWrapper>
      <CheckboxBasedFilter
        title={CaseColumnNames.InStayGuestIssue}
        options={isgiOptions}
        initialValue={inStayGuestIssue}
        onChange={handleDataFilter}
      />
    </CheckBoxWrapper>
  )
}

export const InStayGuestIssueFilter = observer(_InStayGuestIssueFilter)
